"use client"

import { trackEvent } from "./track"

import type { ViewItemEvent, ViewItemListEvent, SelectItemEvent, AddToCartEvent, SearchEvent, SelectContentEvent } from "./types/google"

export function trackViewItem(params: ViewItemEvent["params"]): void {
  trackEvent("view_item", params)
}

// GA's /g/collect rejects a request body over 16KB with a 413, and the whole batch is
// lost with it. A listing page reports 72 products at once, which measured 21,848 bytes
// — every impression on /busqueda was being dropped. Items run around 300 bytes each,
// so 25 leaves room for a page of unusually long titles.
const ITEMS_PER_EVENT = 25

export function trackViewItemList(params: ViewItemListEvent["params"]): void {
  const { items, ...list } = params
  for (let start = 0; start < items.length; start += ITEMS_PER_EVENT) {
    trackEvent("view_item_list", { ...list, items: items.slice(start, start + ITEMS_PER_EVENT) })
  }
}

export function trackSelectItem(params: SelectItemEvent["params"]): void {
  trackEvent("select_item", params)
}

export function trackAddToCart(params: AddToCartEvent["params"]): void {
  trackEvent("add_to_cart", params)
}

export function trackSearch(params: SearchEvent["params"]): void {
  trackEvent("search", params)
}

export function trackSelectContent(params: SelectContentEvent["params"]): void {
  trackEvent("select_content", params)
}
